export default __webpack_public_path__ + "static/media/pp1.5513889e.jpg";